export default {
    data() {
        return {
            loading: false,
        };
    },

    computed: {
        /*
         * Property URL
         */
        productUrl() {
            return route(
                "products.show",
                this.product.slug
            );
        },

        /*
         * Properties do not use product options.
         */
        hasAnyOption() {
            return false;
        },

        hasNoOption() {
            return true;
        },

        /*
         * Property image availability
         */
        hasBaseImage() {
            return !!(
                this.product &&
                this.product.base_image &&
                this.product.base_image.length !== 0
            );
        },

        /*
         * Property main image
         */
        baseImage() {
            if (this.hasBaseImage) {
                return this.product.base_image.path;
            }

            return `${window.FleetCart.baseUrl}/themes/storefront/public/images/image-placeholder.png`;
        },

        /*
         * Membership status
         */
        isMember() {
            return !!(
                window.FleetCart &&
                window.FleetCart.isMember
            );
        },
    },

    methods: {

        /*
         * Property details
         */
        viewProperty() {
            window.location.href = this.productUrl;
        },

        /*
         * Kept as compatibility methods so any old
         * component reference does not break JavaScript.
         */
        syncWishlist() {
            return false;
        },

        syncCompareList() {
            return false;
        },

        addToCart() {
            return false;
        },
    },
};